export default "__VITE_ASSET__0fc27d55__"